export default {
    loading: "Loading"
}